/**
 * ConfiguracaoTemplate — parâmetros por tenant (liga/desliga app público + SMTP de e-mail).
 *
 * Trim pesado de hay-hotspot/assets/reactweb/src/pages/Auth/Configuracao/ConfiguracaoPage.js
 * (Fase 3.2) — removido tudo de captive portal (tema/tamanho de fonte/imagem tela inicial/
 * voucher/MercadoPago/integração ERP/SMS). Sobra só `ativarapp`/e-mail (SMTP), ver
 * `api/models/Configuracao.js`.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Configuracao from '../../../models/Configuracao';

const model = {
  descricao: { exibir: 'main.configuracao.descricao', visivel: true, validacao: { obrigatorio: true } },
  ativarapp: { exibir: 'main.configuracao.ativarapp', visivel: true, tipo: 'boolean' },
  ativaremail: { exibir: 'main.configuracao.ativaremail', visivel: true, tipo: 'boolean' },
  origem: { exibir: 'main.configuracao.origem' },
  usuariosmtp: { exibir: 'main.configuracao.usuariosmtp' },
  senhasmtp: { exibir: 'main.configuracao.senhasmtp', visivel: false },
  servidorsmtp: { exibir: 'main.configuracao.servidorsmtp' },
  portasmtp: { exibir: 'main.configuracao.portasmtp', tipo: 'numeric', keyfilter: 'num' },
};

class ConfiguracaoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.configuracao.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
            <div className="field col-12 md:col-3 mt-3"><ModelBoolean model={model.ativarapp} contexto={contexto} /></div>
            <div className="field col-12 md:col-3 mt-3"><ModelBoolean model={model.ativaremail} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.origem} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.servidorsmtp} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.usuariosmtp} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelSenha model={model.senhasmtp} contexto={contexto} mostrarMetricas={false} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.portasmtp} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class ConfiguracaoTemplate extends Component {
  render() {
    return (
      <EntityGrid
        entidade={Configuracao}
        model={model}
        identidade="main.configuracao"
        permissoes={this.props.permissoes}
        icone="pi-cog"
        storageKey="dt-configuracoes"
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={(m, ctx) => <ConfiguracaoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default ConfiguracaoTemplate;
